import { render, staticRenderFns } from "./ListWidgetCustomizer.vue?vue&type=template&id=35a77c22&"
import script from "./ListWidgetCustomizer.vue?vue&type=script&lang=js&"
export * from "./ListWidgetCustomizer.vue?vue&type=script&lang=js&"
import style0 from "./ListWidgetCustomizer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports